<template>
  <div id="app-2020-01-4g">
    <p class="yddviz-radiogroup">
      <button v-for="view in views" class="yddviz-radio" @click="selectView(view)" :class="[ currentView === view ? 'active' : '' ]" :key="view.slug">
        {{ view.title }}
      </button>
    </p>
    <div class="yddviz-row">
      <div class="column">
        <div id="networkMap"></div>
      </div>
      <div class="column">
        <div class="info">
          <select v-model="selectedId" @change="dropdownSelect" class="yddviz-select">
            <option value="000">Välj kommun</option>
            <option v-for="muni in kommuner" :value="muni.id" :key="muni.id">{{ muni.kommun }}</option>
          </select>
          <div v-if="selectedRegion">
            <h3>{{ selectedRegion.feature.properties.kommun }}</h3>
            <table>
              <tbody>
                <tr>
                  <td>Genomsnittlig topphastighet 2019 * (4G)</td>
                  <td>{{ selectedRegion.feature.properties.hastighet_2019 | formatNumber }} Mbit/s</td>
                </tr>
                <tr>
                  <td>Genomsnittlig topphastighet 2018 (4G)</td>
                  <td>{{ selectedRegion.feature.properties.hastighet_2018 | formatNumber }} Mbit/s</td>
                </tr>
                <tr>
                  <td>Andel med fast anslutning ≥ 100 Mbit/s</td>
                  <td>{{ Math.round(selectedRegion.feature.properties.fiber * 100) }} %</td>
                </tr>
              </tbody>
            </table>
            <p>* Antal mätningar: {{ selectedRegion.feature.properties.matning | formatNumber }}</p>
            <p><em>Källa: Netradar, Traficom</em></p>
          </div>
          <div v-else>
            <p>Välj en kommun för att se mer detaljerad information genom att klicka på kartan eller välja i menyn ovan.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import L from 'leaflet'

import data4g from './data/4g-karta.json'
import kommuner from './data/kommuner.json'

const scale = ['#f9ddda', '#e3aac6', '#cc77b2', '#91599d', '#573b88'];
const altScale = ['#d01c8b','#f1b6da','#e9e9e9','#b8e186','#4dac26'];
const mapBounds = new L.LatLngBounds(new L.LatLng(58, 17), new L.LatLng(72, 32));

export default {
  name: 'app',
  components: {
  },
  data () {
    return {
      map: null,
      geoJson: null,
      legend: null,
      selectedRegion: null,
      previousRegion: null,
      selectedId: '000',
      kommuner,
      currentView: null,
      views: [
        {
          slug: 'hastighet_2019',
          title: 'Hastighet 2019',
          legend: 'Topphastighet,<br>Mbit/s',
          limits: [0, 15, 20, 25, 30],
          labels: ['< 15', '15 - 20', '20 - 25', '25 - 30', '> 30'],
          scale: scale,
        },
        {
          slug: 'hastighet_2018',
          title: 'Hastighet 2018',
          legend: 'Topphastighet,<br>Mbit/s',
          limits: [0, 15, 20, 25, 30],
          labels: ['< 15', '15 - 20', '20 - 25', '25 - 30', '> 30'],
          scale: scale,
        },
        {
          slug: 'skillnad',
          title: 'Skillnad 2018-2019',
          legend: 'Skillnad,<br>Mbit/s',
          limits: [-999, -10, -3, 3, 10],
          labels: ['< -15', '-15 – -3', '-3 – 3', '3 – 15', '> 15'],
          scale: altScale,
        },
        {
          slug: 'fiber',
          title: 'Fasta anslutningar',
          legend: 'Andel med<br>≥ 100 Mbit/s',
          limits: [0, 0.15, 0.4, 0.6, 0.8],
          labels: ['0 - 15 %', '15 - 40 %', '40 - 60 %', '60 - 80 %', '80 - 100 %'],
          scale: scale,
        },
      ],
    }
  },
  mounted() {
    this.currentView = this.views[0];
    this.initMap();
  },
  filters: {
    formatNumber(value) {
      return value.toLocaleString('sv-FI');
    },
  },
  methods: {
    selectView(view) {
      this.currentView = view;
      this.geoJson.setStyle(this.style);
      this.highlight(this.selectedRegion);

      this.legend.remove();
      this.legend.addTo(this.map);
    },
    select(layer) {
      if (this.selectedRegion !== null) {
        this.previousRegion = this.selectedRegion;
      }
      this.highlight(layer);
      const bounds = layer.getBounds();
      const center = bounds.getCenter();
      this.map.setView(center, 7);
      this.selectedRegion = layer;
      if (this.previousRegion) {
        this.dehighlight(this.previousRegion);
			}
		},
    dropdownSelect() {
      this.geoJson.eachLayer((layer) => {
        if (layer.feature.properties.kunta == this.selectedId) {
          this.select(layer);
        }
      });
    },
    highlight(layer) {
      if (layer) {
        layer.setStyle({
          color: '#ffd000',
          weight: 4,
        });
        if (!L.Browser.ie && !L.Browser.opera) {
          layer.bringToFront();
        }
      }
		},
		dehighlight(layer) {
      if (this.selectedRegion === null || this.selectedRegion._leaflet_id !== layer._leaflet_id) {
        layer.setStyle({
          color: '#fff',
          weight: 1,
        });
      }
    },
    style(feature) {
      if (typeof feature.properties[this.currentView.slug] !== 'undefined') {
        return {
          fillColor: this.getColor(feature.properties[this.currentView.slug]),
          weight: 1,
          opacity: 0.5,
          color: '#fff',
          fillOpacity: 1,
        };
      }
      else {
        return {
          fillColor: 'transparent',
          color: 'transparent',
        };
      }
    },
    getColor(d) {
      return d > this.currentView.limits[4] ? this.currentView.scale[4] :
        d > this.currentView.limits[3] ? this.currentView.scale[3] :
        d > this.currentView.limits[2] ? this.currentView.scale[2] :
        d > this.currentView.limits[1] ? this.currentView.scale[1] :
          this.currentView.scale[0];
    },
    initMap() {
      this.map = L.map('networkMap', {
        // zoomControl: false,
        // scrollWheelZoom: false,
        maxZoom: 9,
        minZoom: 4,
        dragging: !L.Browser.mobile,
        maxBounds: mapBounds,
        maxBoundsViscosity: 0.5,
      });

      this.geoJson = L.geoJSON(data4g, {
        style: this.style,
        onEachFeature: this.onEachFeature,
      });
      this.geoJson.addTo(this.map);

      this.map.fitBounds(this.geoJson.getBounds());

      this.legend = L.control({position: 'bottomright'});
      this.legend.onAdd = () => {
        const div = L.DomUtil.create('div', 'mapLegend');

        div.innerHTML =
          '<strong>' + this.currentView.legend + '</strong><br>' +
          '<i style="background: ' + this.currentView.scale[4] + '"></i> ' + this.currentView.labels[4] + '<br>' +
          '<i style="background: ' + this.currentView.scale[3] + '"></i> ' + this.currentView.labels[3] + '<br>' +
          '<i style="background: ' + this.currentView.scale[2] + '"></i> ' + this.currentView.labels[2] + '<br>' +
          '<i style="background: ' + this.currentView.scale[1] + '"></i> ' + this.currentView.labels[1] + '<br>' +
          '<i style="background: ' + this.currentView.scale[0] + '"></i> ' + this.currentView.labels[0];

        return div;
      };
      this.legend.addTo(this.map);
    },
    onEachFeature(feature, layer) {
      layer.on({
        'click': (e) => {
          this.selectedId = e.target.feature.properties.kunta;
          this.select(e.target);
        }
      });
    },
  },
}
</script>

<style lang="scss">
@import "~leaflet/dist/leaflet.css";

#app-2020-01-4g {
  font-family: Arial, sans-serif;
  max-width: 980px;
  margin: 0 auto;

  #networkMap {
    height: 600px;
    max-height: 80vh;
    margin-bottom: 10px;
    z-index: 0;
    background-color:rgba(255,0,0,0.0);
  }

  h3 {
    margin-top: 0;
  }

  .mapLegend {
    padding: 6px 8px;
    font: 14px/16px Arial, Helvetica, sans-serif;
    background: white;
    background: rgba(255,255,255,0.8);
    box-shadow: 0 0 15px rgba(0,0,0,0.2);
    border-radius: 5px;
    line-height: 18px;
    color: #555;

    i {
      width: 18px;
      height: 18px;
      float: left;
      margin-right: 8px;
      opacity: 1;
    }
  }

  table {
    background: #fff;
    color: #000;
    width: 100%;
    border-collapse: collapse;
    margin: 0;
    padding: 0;

    td, th {
      padding: 8px;
      line-height: 1.4;
      text-align: left;
    }
    
    tbody tr {
      border-bottom: 2px solid #eee;

      td {
        &:last-child {
          text-align: right;
        }

        background: #fff;
      }
    }
  }
}

.yddviz-select {
  display: block;
  margin: 0 auto 1em auto;
  border: 2px solid #333;
  border-radius: 6px;
  padding: 6px;
  width: 100%;
  max-width: 400px;
  font-size: 16px;
  line-height: 1.5;

  &:focus {
    outline: none;
    border: 2px dashed #333;
    background: #f5f5f5;
  }
}

.yddviz-row {
  .info {
    padding: 10px;
  }

  @media (min-width: 576px) {
    .column {
      width: 50%;
      float: left;
    }
    .info {
      padding: 20px;
    }
  }

  &::after {
    content: "";
    clear: both;
    display: table;
  }
}

.yddviz-radio {
  text-decoration: none;
  background: #fff;
  color: #333;
  font-family: "Arial", sans-serif;
  border-radius: 4px;
  border: 2px solid #333;
  font-size: 0.75em;
  padding: 8px;
  border-radius: 4px;
  display: block;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  word-break: keep-all;
  white-space: nowrap;
  cursor: pointer;
  margin: 0 auto;
  line-height: 1;
  transition: background-color .5s;

  &:hover {
    background-color: #333;
    color: white;
  }

  &:focus {
    outline: none;
    text-decoration: none;
    border: 2px dashed #333;
  }

  &.active {
    background-color: #333;
    color: white;

    &:focus {
      outline: none;
      text-decoration: none;
      border: 2px dashed #fff
    }

    &:hover {
      background-color: #111;
    }
  }
}

.yddviz-radiogroup {
  max-width: 500px;
  margin: 0 auto 1em;

  .yddviz-radio {
    margin-right: 4px;
    margin-bottom: 4px;
    display: inline-block;
    width: calc(50% - 2px);

    &:nth-child(even) {
      margin-right: 0;
    }
  }
}
</style>
